class AppFooter extends Component {
    constructor(el) {
        super(el);
        this.navOpener = this.$findAll('[data-nav-opener]');
        this.addEventListeners();
    }

    addEventListeners() {
        this.navOpener.forEach((el) => {
            el.addEventListener('click', () => {
                el.parentElement.classList.toggle('is-open');
            });
        });
    }
}